module.exports = __webpack_public_path__ + "img/tips-descent.b4727b06.svg";